/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Clickup_LeadInputs */

const en_mk_cmp_clickup_lead = /** @type {(inputs: Mk_Cmp_Clickup_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ClickUp offers nearly everything in one product, which is both its strength and its weight. This comparison focuses on the two things people feel most: what the AI bill comes to, and how quickly non-technical people can actually use it.`)
};

const id_mk_cmp_clickup_lead = /** @type {(inputs: Mk_Cmp_Clickup_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ClickUp menawarkan hampir semua hal dalam satu produk, dan itulah kekuatan sekaligus bebannya. Perbandingan ini berfokus pada dua hal yang paling terasa: berapa tagihan AI-nya, dan seberapa cepat orang non-teknis bisa memakainya.`)
};

/**
* | output |
* | --- |
* | "ClickUp offers nearly everything in one product, which is both its strength and its weight. This comparison focuses on the two things people feel most: what ..." |
*
* @param {Mk_Cmp_Clickup_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_clickup_lead = /** @type {((inputs?: Mk_Cmp_Clickup_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Clickup_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_clickup_lead(inputs)
	return en_mk_cmp_clickup_lead(inputs)
});